import * as React from "react";
import styled, { css } from "styled-components";

import { PopoverContainer } from "../../common/components/popover";

type CompanyValueFeature = WtdModels.Partial<
  WtdModels.CompanyValueFeature,
  "feature" | "feature_title" | "feature_help"
>;

export interface CompanyValuesPickerItemModels {
  CompanyValueFeature: CompanyValueFeature;
}

interface Props {
  feature: CompanyValueFeature;
  selectedIndex?: number;
  onSelect(feature: CompanyValueFeature): void;
  onUnselect(feature: CompanyValueFeature): void;
}

class CompanyValuesPickerItem extends React.PureComponent<Props> {
  public onClick = () => {
    const { feature, selectedIndex, onSelect, onUnselect } = this.props;
    if (selectedIndex === undefined) {
      onSelect(feature);
    } else {
      onUnselect(feature);
    }
  };

  public render() {
    const { feature, selectedIndex } = this.props;
    return (
      <PopoverContainer
        render={({ top, left }) => {
          if (!feature.feature_help) {
            return null;
          }
          return <StyledHint style={{ top, left }}>{feature.feature_help}</StyledHint>;
        }}
      >
        {({ onOpen, onClose, setRef }) => {
          return (
            <Wrapper
              key={feature.feature}
              onMouseEnter={() => onOpen({ delay: 60 })}
              onMouseLeave={() => onClose({ delay: 100 })}
            >
              <Item role="checkbox" onClick={this.onClick}>
                <Index isSelected={selectedIndex !== undefined}>{selectedIndex}</Index>
                <FeatText innerRef={setRef}>{feature.feature_title}</FeatText>
              </Item>
            </Wrapper>
          );
        }}
      </PopoverContainer>
    );
  }
}

const Wrapper = styled.div`
  display: block;
  margin-bottom: 3px;
`;

const Item = styled.div`
  padding: 8px 20px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.56);
  cursor: pointer;
  &:hover {
    background-color: rgba(238, 238, 238, 1);
  }
`;

const Index = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  line-height: 20px;
  font-weight: 400;
  color: white;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
  ${(props: { isSelected: boolean }) =>
    props.isSelected
      ? css`
          background-color: rgba(33, 189, 219, 1);
        `
      : css`
          border: solid 1px rgba(0, 0, 0, 0.12);
        `};
`;

const FeatText = styled.span`
  display: inline-block;
  height: 20px;
  vertical-align: middle;
`;

const StyledHint = styled.div`
  position: absolute;
  z-index: 1;
  margin-left: 6px;
  transform: translate(50px, calc(-100% - 10px));
  max-width: 210px;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  line-height: 1.6;
  border-radius: 10px;
`;

export default CompanyValuesPickerItem;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesPickerItem.tsx